import Vue from 'vue';
import ImageApp from './App.vue';
import store from './store/index';

Vue.config.productionTip = false;

const element = document.getElementById('image-tool');

if (element !== null) {
    new Vue({
        created() {
            Vue.prototype.$baseUrl = element.dataset.baseUrl;
            Vue.prototype.$id = element.dataset.id;
            Vue.prototype.$initData = element.dataset;
        },
        store,
        render: h => h(ImageApp)
    }).$mount('#image-tool');
}

